import { render } from "./SignUpMFAComponent.vue?vue&type=template&id=19e3710c&scoped=true"
import script from "./SignUpMFAComponent.vue?vue&type=script&lang=js"
export * from "./SignUpMFAComponent.vue?vue&type=script&lang=js"

import "./SignUpMFAComponent.vue?vue&type=style&index=0&id=19e3710c&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e3710c"]])

export default __exports__